import useConfig from 'Hooks/useConfig';
import { ReactNode } from 'react';
import { Auth0Provider, AppState } from '@auth0/auth0-react';
import BackdropLoader from 'Components/BackdropLoader';
import { useNavigate } from 'react-router-dom';

const AuthProvider = ({ children }: { children: ReactNode }) => {
  const {
    config: { auth0Domain, auth0CMSClientId, auth0Audience }
  } = useConfig();
  const navigate = useNavigate();

  const onRedirectCallback = (appState: AppState | undefined) => {
    navigate(appState?.returnTo || window.location.pathname);
  };

  return auth0CMSClientId && auth0Domain ? (
    <Auth0Provider
      domain={auth0Domain}
      clientId={auth0CMSClientId}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: auth0Audience
      }}
      useRefreshTokens={true}
      cacheLocation="localstorage"
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  ) : (
    <BackdropLoader />
  );
};

export default AuthProvider;
